import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from '@/const';
import UserApi from '@/api/UserApi';
import {ICurrentUser} from '@/api/interfaces';
import {IUserData} from './interfaces';

const useCurrentUser = ({loginParams, _fields}: ICurrentUser) => {
    return useQuery({
        queryKey: [QUERY_KEYS.users.currentUser],
        queryFn: ({signal}) => UserApi.getCurrentUser({loginParams, _fields, signal}),
        select: data => data?.data as IUserData | undefined
    });
};

export default useCurrentUser;
